import { render, staticRenderFns } from "./DevPanel.vue?vue&type=template&id=d4dc1d48&scoped=true&"
import script from "./DevPanel.vue?vue&type=script&lang=js&"
export * from "./DevPanel.vue?vue&type=script&lang=js&"
import style0 from "./DevPanel.vue?vue&type=style&index=0&id=d4dc1d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc1d48",
  null
  
)

export default component.exports